import getLocale from 'helpers/getLocale';

const DEFAULT_LANGUAGE = 'en';

/**
 * Get the current language code
 * Used by various components to determine the current locale
 */
export const getLanguage = () => {
  const language = getLocale();
  if (language) {
    return language;
  }
  return DEFAULT_LANGUAGE;
};

// Re-export for backwards compatibility
const translation = { getLanguage };
export default translation;
